<div class="risk-item">
  <h3>{{ indicator().indicator }}</h3>
  @if (indicator().status) {
    <app-basic-tags [tags]="[mapStatus()[indicator().status]]"></app-basic-tags>
  }

  @if (indicator().guidance) {
    <h4>{{ translations.guidance }}</h4>
    <p class="break-word" [innerHTML]="guidance()"></p>
  }

  @if (indicator().note) {
    <h4>{{ translations.note }}</h4>
    <p class="break-word" [innerHTML]="note()"></p>
  }

  @if (shouldDisplayMitigations()) {
    <h4>{{ translations.mitigations }}</h4>
    @for (mitigation of mitigations(); track mitigation.id) {
      <app-risk-assessment-report-mitigation-print-view
        [mitigation]="mitigation"
      ></app-risk-assessment-report-mitigation-print-view>
    }
  }
</div>
